import axios from 'axios';
import { API_URL } from './common';
import { Contact, CreateContact } from '../models/contact';

const createContact = async (data: CreateContact): Promise<Contact> => {
  try {
    const response = await axios.post(`${API_URL}/api/v1/contact/create`, data);
    return response.data;
  } catch (error: any) {
    console.error('Get user error:', error.response?.data || error.message);
    throw error;
  }
};

const getContacts = async (): Promise<Contact[]> => {
  try {
    const response = await axios.get(`${API_URL}/api/v1/contact/all`);
    return response.data;
  } catch (error: any) {
    console.error('Get contacts error:', error.response?.data || error.message);
    throw error;
  }
};

const updateContact = async (id: number, data: Contact): Promise<Contact> => {
  try {
    const response = await axios.put(
      `${API_URL}/api/v1/contact/${id}/update`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error(
      'Update contact error:',
      error.response?.data || error.message
    );
    throw error;
  }
};

const deleteContact = async (id: number): Promise<void> => {
  try {
    await axios.delete(`${API_URL}/api/v1/contact/${id}/delete`);
  } catch (error: any) {
    console.error(
      'Delete contact error:',
      error.response?.data || error.message
    );
    throw error;
  }
};

const contactService = {
  createContact,
  getContacts,
  updateContact,
  deleteContact,
};

export default contactService;
